import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProject, BackendQueryProjectArgs } from 'src/types/backend';

const QUERY = gql`
  query ProjectCommonData($projectId: Int!) {
    project(id: $projectId) {
      id

      # AI Agent conversation
      conversation {
        id
        externalConversationId
      }

      # "last used panel" detection: the newest card of each section
      sections {
        id
        assetGroups(first: 1) {
          edges {
            node {
              id
              sourceType
              createdAt
            }
          }
        }
      }

      # "last used asset type" detection
      generationRequests(first: 1) {
        edges {
          node {
            ... on RecomposeRequest {
              recomposeMode
              assetType
              generationTool
              chainGenerationTool
              chainId
              language
              languageTargetFormality
              briefTitle
              briefBody
              emailPromotion
              sourceType
              generationGuidance {
                campaignKeywords
              }
            }
            ... on SuggestionRequest {
              suggestionMode
              assetType
              generationTool
              chainGenerationTool
              customMultiPromptId
              chainId
              language
              languageTargetFormality
              briefTitle
              briefBody
              emailPromotion
              sourceType
              freestyleToolId
              freestyleToolAllInstructions
              freestyleToolAllInstructionsData
              subTemplate {
                id
              }
              generationGuidance {
                campaignKeywords
              }
            }
          }
        }
      }
    }
  }
`;

type Variables = {
  projectId: BackendQueryProjectArgs['id'];
};
type Result = BackendProject;

export const queryProjectCommonData = async (
  { projectId }: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { projectId },
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(result.data);
};
